var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.$route.name !== 'login')?_c('header-main'):_vm._e(),_c('div',{staticClass:"wrapper"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }